import { defineStore } from "pinia";
import { ref } from "vue";

export const useGeneralStore = defineStore("general", () => {
    /*###################
    ### ENV VARIABLES ###
    ###################*/
    const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;
    const API_BASE_PATH = `${API_BASE_URL}${import.meta.env.VITE_API_BASE_PATH}`;
    const APP_VERSION = import.meta.env.VITE_NPM_PACKAGE_VERSION;

    /*#########
    ### APP ###
    #########*/
    const app_booted = ref<boolean>(false);
    const app_boot_promise: Promise<void> = new Promise<void>(resolve => {
        function c() {
            if (app_booted.value) {
                return resolve();
            }

            setTimeout(c, 150);
        }
        c();
    });
    function setAppBooted(state: boolean) {
        app_booted.value = state;
    }

    return {
        API_BASE_URL,
        API_BASE_PATH,

        APP_VERSION,

        app_booted,
        app_boot_promise,
        setAppBooted
    };
});
